import * as React from 'react';
import styled from 'styled-components';
import { intlShape } from 'react-intl';
import { media } from './style-utils';
export interface Props {
  country: string;
}

const Wrapper = styled.footer`
  display: block;
  width: 100%;
  position: absolute;
  bottom: 0;
  margin-top: 60px;
  background: #333;
  text-align: center;
  height: 33px;
  padding-top: 15px;
  a {
    color: #fff;
    text-decoration: none;
    font-size: 12px;
    &:nth-child(2) {
      &:before {
        content: '|';
        margin: 3px;
      }
      &:after {
        content: '|';
        margin: 3px;
      }
    }
    ${media['phone']`
      font-size: 10px;
    ;`}
  }
`;

class Footer extends React.Component<Props, null> {
  static get contextTypes() {
    return { intl: intlShape };
  }
  render() {
    const { country } = this.props;
    const { formatMessage } = this.context.intl;
    const toreta_asia = ['sg', 'vn', 'th', 'my', 'id', 'ph', 'kh', 'hk'];
    const toreta_taiwan = ['tw'];
    let privacyUrl = 'https://corp.toreta.in/privacy';
    let termsUrl = 'https://toreta.in/jp/web_reservation/terms`';
    let siteUrl = 'https://toreta.in/jp/';
    if (toreta_asia.indexOf(country) > -1) {
      privacyUrl = 'http://toretaasia.com/privacy-policy/';
      termsUrl = 'http://toretaasia.com/terms-of-service/';
      siteUrl = 'http://toretaasia.com';
    }
    // Toreta Taiwan, Inc
    else if (toreta_taiwan.indexOf(country) > -1) {
      privacyUrl = 'http://toretaasia.com/tw/privacy-policy/';
      termsUrl = 'http://toretaasia.com/tw/terms-of-service/';
      siteUrl = 'http://toretaasia.com/tw/';
    }
    // 株式会社トレタ
    else {
      // 日本語
      if (this.context.intl.locale === 'ja') {
        privacyUrl = `https://corp.toreta.in/privacy`;
        termsUrl = `https://toreta.in/jp/web_reservation/terms`;
      }
      // 日本語以外
      else {
        privacyUrl = `https://corp.toreta.in/privacy-en`;
        termsUrl = `https://toreta.in/jp/web_reservation/terms_en`;
      }
    }
    return (
      <Wrapper>
        <a target="_blank" href={privacyUrl}>
          {formatMessage({ id: 'privacyPolicy' })}
        </a>
        <a target="_blank" href={termsUrl}>
          {formatMessage({ id: 'term' })}
        </a>
        <a className="logo" target="_blank" href={siteUrl}>
          powered by <span className="icon-logo" />
        </a>
      </Wrapper>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/Footer.tsx